import React from 'react';
import { Stack, Box, Slider, Center, Text, Group } from '@mantine/core';
import { IJournalResponseInput } from '../../../../global/entities/Journal/Journal';

// Emoji mapping for scale values 0-10
const getEmojiForValue = (value: number, isReversed: boolean = false): string => {
    const emojis = ['😢', '😟', '😞', '😐', '😔', '😐', '🙂', '😊', '😄', '😁', '🤩'];
    
    if (isReversed) {
        // Reverse the emoji array so value 0 gets the happiest emoji
        const reversedEmojis = [...emojis].reverse();
        return reversedEmojis[Math.round(Math.max(0, Math.min(10, value)))] || '😐';
    }
    
    return emojis[Math.round(Math.max(0, Math.min(10, value)))] || '😐';
};

interface ScaleQuestionProps {
    questionId: number;
    response: IJournalResponseInput | undefined;
    onResponseChange: (questionId: number, updates: Partial<IJournalResponseInput>) => void;
    readOnly?: boolean;
    isReversed?: boolean;
}

export const ScaleQuestion: React.FC<ScaleQuestionProps> = ({
    questionId,
    response,
    onResponseChange,
    readOnly = false,
    isReversed = false
}) => {
    // Handle null/undefined values - don't default to 0
    const hasResponse = response?.responseValue !== undefined && response?.responseValue !== null && response?.responseValue !== '';
    const scaleValue = hasResponse && response?.responseValue ? parseFloat(response.responseValue) : null;

    return (
        <Stack gap="md">
            <Box>
                <Center mb="xl" mt="-1rem">
                    <Group gap="md">
                        {hasResponse && scaleValue !== null ? (
                            <>
                                <Text size="2rem" style={{ lineHeight: 1 }}>{getEmojiForValue(scaleValue, isReversed)}</Text>
                                <Text fw={700} size="2rem" style={{ lineHeight: 1 }}>{scaleValue}</Text>
                            </>
                        ) : (
                            <>
                                <Text fw={700} size="2rem" style={{ lineHeight: 1, color: 'var(--mantine-color-dimmed)' }}>–</Text>
                            </>
                        )}
                    </Group>
                </Center>
                
                <Slider
                    value={scaleValue ?? 0}
                    onChange={readOnly ? undefined : (value) => onResponseChange(questionId, { responseValue: value.toString() })}
                    min={0}
                    max={10}
                    step={1}
                    marks={Array.from({ length: Math.floor((10 - 0) / 1) + 1 }, (_, i) => {
                        const markValue = 0 + (i * 1);
                        return {
                            value: markValue,
                            label: getEmojiForValue(markValue, isReversed)
                        };
                    })}
                    mb="md"
                    styles={{
                        thumb: {
                            opacity: hasResponse && scaleValue !== null ? 1 : 0,
                            pointerEvents: hasResponse && scaleValue !== null ? 'auto' : 'none'
                        },
                        bar: {
                            display: hasResponse && scaleValue !== null ? 'block' : 'none'
                        }
                    }}
                />
            </Box>
        </Stack>
    );
}; 